import React, { useState, useEffect } from 'react';
import { Space, Table, Tag, Drawer, Button, Popconfirm, message } from 'antd';
import { GREEN_TAG, RED_TAG, DEFAULT_MASTER_DRAWER_WIDTH } from '../../../utility/Constants';
import CustomTableSearch from "../../common/CustomTableSearch";
import bankMasterService from "../../../api/bank.service";
import { useDispatch, useSelector } from 'react-redux';
import DrawableCloseIcon from "../../common/DrawableCloseIcon";
import BankEntry from './BankEntry';
import { EditOutlined } from "@ant-design/icons";

const BankList = () => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state.bank);

    const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;

    const [filteredSearchList, setFilteredSearchList] = useState([]);
    const [page, setPage] = useState(1);
    const [bankList, setBankList] = useState([]);
    const [visible, setVisible] = useState(false);
    const [bankAddData, setBankAddData] = useState({
        bank_id: 0,
        bank_name: '',
        // is_active: 'Y',
    });

    const showDrawer = (rowdata) => {
        console.log("Fetching bank details for bank_id:", rowdata.bank_id);
        bankMasterService.edit({ bank_id: rowdata.bank_id }).then((resdata) => {
            console.log("Fetched bank data:", resdata.response_data);
            const data = resdata.response_data;
            setBankAddData({
                bank_id: data.bank_id,
                bank_name: data.bank_name,
                // bank_short_name: data.bank_short_name,
                // bank_type: data.bank_type,
                is_active: data.is_active,
                mode: "EDIT"
            });
            setVisible(true);
        }).catch((error) => {
            console.error("Error fetching bank details:", error);
        });
    };
    // const handleStatusChange = (record) => {
    //     const newStatus = record.is_active === 'Y' ? 'N' : 'Y';
    
    //     // Assuming bankMasterService.updateStatus sends a PUT/POST request to update status
    //     bankMasterService.list({ bank_id: record.bank_id, is_active: newStatus })
    //         .then(() => {
    //             message.success(`Bank status updated to ${newStatus === 'Y' ? 'Active' : 'Inactive'}`);
    //             // Update local state
    //             setBankList(prevList => 
    //                 prevList.map(item => item.bank_id === record.bank_id ? { ...item, is_active: newStatus } : item)
    //             );
    //             setFilteredSearchList(prevList => 
    //                 prevList.map(item => item.bank_id === record.bank_id ? { ...item, is_active: newStatus } : item)
    //             );
    //         })
    //         .catch(error => {
    //             console.error("Error updating bank status:", error);
    //             message.error('Failed to update bank status.');
    //         });
    // };
    

    const columns = [
        {
            title: '#',
            dataIndex: 'index',
            render: (text, record, index) => (page - 1) * 10 + ++index,
            width: '5%',
        },
        {
            title: 'Name',
            dataIndex: 'bank_name',
            key: 'bank_name',
            sorter: (a, b) => a.bank_name.localeCompare(b.bank_name),
        },
        // {
        //     title: 'Active',
        //     dataIndex: 'is_active',
        //     key: 'is_active',
        //     sorter: (a, b) => a.is_active.localeCompare(b.is_active),
        //     render: (text, record) => (
        //         <Space size="middle">
        //             <Button
        //                 style={{
        //                     backgroundColor: record.is_active === 'Y' ? GREEN_TAG : RED_TAG,
        //                     color: '#fff'
        //                 }}
        //                 onClick={() => handleStatusChange(record)}
        //             >
        //                 {record.is_active === 'Y' ? 'Active' : 'Not Active'}
        //             </Button>
        //         </Space>
        //     ),
        // },
        {
            title: 'Action',
            key: 'action',
            render: (selectedObj) => (
                <Space size="middle">
                    <Button htmlType="button" type="ghost" size="small" shape="round" onClick={() => showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
                </Space>
            ),
        },
    ];

    const onClose = () => {
        setVisible(false);
    };

    useEffect(() => {
        bankMasterService.list().then((res) => {
            setBankList(res.data.response_data);
            setFilteredSearchList(res.data.response_data);
        });
    }, [state.bank]);

    const onSearch = (e) => {
        const searchString = e.target.value.toLowerCase();
        const filteredList = bankList.filter(data => {
            const dataString = JSON.stringify(data).toLowerCase();
            return dataString.includes(searchString);
        });
        setFilteredSearchList(filteredList);
    };

    return (
        <>
            <CustomTableSearch onSearchTable={onSearch} />
            <Table
                columns={columns}
                rowKey='bank_id'
                dataSource={filteredSearchList}
                pagination={{
                    showTotal,
                    onChange(current) {
                        setPage(current);
                    }
                }}
                size='small'
            />

            <Drawer
                title="Edit Bank"
                width={DEFAULT_MASTER_DRAWER_WIDTH}
                onClose={onClose}
                visible={visible}
                bodyStyle={{
                    paddingBottom: 80,
                }}
                destroyOnClose={true}
                closeIcon={<DrawableCloseIcon />}
            >
                <BankEntry data={bankAddData} onDrawerClose={onClose} />
            </Drawer>
        </>
    );
};

export default BankList;
